import { useEffect, useState } from 'react';
import { SITE_CONFIG } from '../config';

const SitemapXML = () => {
  const [xmlContent, setXmlContent] = useState('');

  useEffect(() => {
    const fetchSitemap = async () => {
      try {
        const response = await fetch(`https://tophamtechbe.com/api/treas/ads/v1/get-sitemap/${SITE_CONFIG.SITE_ID}`, {
          headers: { 'X-API-Key': 'treas-api-key-2025' }
        });
        
        if (response.ok) {
          const data = await response.json();
          setXmlContent(data.xml_content || 'No sitemap content available');
        }
      } catch (error) {
        console.error('Error fetching sitemap:', error);
      }
    };
    
    fetchSitemap();
  }, []);

  // Set content type header
  useEffect(() => {
    if (xmlContent) {
      document.querySelector('meta[http-equiv="Content-Type"]')?.remove();
      const meta = document.createElement('meta');
      meta.setAttribute('http-equiv', 'Content-Type');
      meta.setAttribute('content', 'text/xml');
      document.head.appendChild(meta);
    }
  }, [xmlContent]);

  return (
    <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
      {xmlContent}
    </pre>
  );
};

export default SitemapXML;